import { ProjectFile } from '../../types';

export function getCompileTargetFile(
  files: ProjectFile[],
  activeFile: ProjectFile | null
): ProjectFile | null {
  void activeFile;
  return files.find((file) => file.name === 'main.tex') || null;
}

export function getAIValidationTargetFile(files: ProjectFile[]): ProjectFile | null {
  return files.find((file) => file.name === 'main.tex') || null;
}
